import dayjs from 'dayjs'
import { DaylightDateFormat } from '@/constants/DaylightDateFormat'

/**
 * Mock CloudWatch Logs Data - Linehaul Workstream
 * Matches the actual CloudWatch API response structure
 */
export const mockCloudWatchLogsLinehaul = {
  workstream: 'linehaul',
  environment: null,
  total_logs: 45,
  count_4xx: 38,
  count_5xx: 7,
  lambda_logs: [
    {
      stack_name: 'apex-linehaul-linehaul-prod',
      lambda_function_name: 'linehaul-prod-trips-processor',
      log_group: '/aws/lambda/linehaul-prod-trips-processor',
      region: 'us-west-1',
      logs_found: 15,
      count_4xx: 12,
      count_5xx: 3,
      logs: [
        {
          timestamp: dayjs().subtract(2, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "ERROR", "message": "Trip validation failed: Invalid stop sequence", "requestId": "a1b2c3d4-e5f6-7890-abcd-ef1234567890", "method": "POST", "path": "/linehaul/api/v1/trips/create", "statusCode": 400, "durationMs": 45.2, "success": false}',
          status_code: '400',
        },
        {
          timestamp: dayjs().subtract(3, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "ERROR", "message": "Database connection timeout", "requestId": "b2c3d4e5-f6g7-8901-bcde-f12345678901", "method": "GET", "path": "/linehaul/api/v1/trips/active", "statusCode": 500, "durationMs": 30000, "success": false}',
          status_code: '500',
        },
        {
          timestamp: dayjs().subtract(5, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Shipment ID not found in system", "requestId": "c3d4e5f6-g7h8-9012-cdef-123456789012", "method": "PUT", "path": "/linehaul/api/v1/shipments/update", "statusCode": 404, "durationMs": 23.5, "success": false}',
          status_code: '404',
        },
      ],
    },
    {
      stack_name: 'apex-linehaul-linehaul-qa',
      lambda_function_name: 'linehaul-qa-route-optimizer',
      log_group: '/aws/lambda/linehaul-qa-route-optimizer',
      region: 'us-west-1',
      logs_found: 20,
      count_4xx: 18,
      count_5xx: 2,
      logs: [
        {
          timestamp: dayjs().subtract(1, 'hour').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Invalid route parameters provided", "requestId": "d4e5f6g7-h8i9-0123-defg-234567890123", "method": "POST", "path": "/linehaul/api/v1/routes/optimize", "statusCode": 400, "durationMs": 15.8, "success": false}',
          status_code: '400',
        },
        {
          timestamp: dayjs().subtract(4, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "ERROR", "message": "Route optimization service unavailable", "requestId": "e5f6g7h8-i9j0-1234-efgh-345678901234", "method": "POST", "path": "/linehaul/api/v1/routes/optimize", "statusCode": 503, "durationMs": 5000, "success": false}',
          status_code: '503',
        },
      ],
    },
    {
      stack_name: 'apex-linehaul-linehaul-dev',
      lambda_function_name: 'linehaul-dev-auth',
      log_group: '/aws/lambda/linehaul-dev-auth',
      region: 'us-west-1',
      logs_found: 10,
      count_4xx: 8,
      count_5xx: 2,
      logs: [
        {
          timestamp: dayjs().subtract(6, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Authentication token expired", "requestId": "f6g7h8i9-j0k1-2345-fghi-456789012345", "method": "GET", "path": "/linehaul/api/v1/auth/verify", "statusCode": 401, "durationMs": 12.3, "success": false}',
          status_code: '401',
        },
      ],
    },
  ],
}

/**
 * Mock CloudWatch Logs Data - BackOffice Workstream
 */
export const mockCloudWatchLogsBackoffice = {
  workstream: 'back-office',
  environment: null,
  total_logs: 50,
  count_4xx: 50,
  count_5xx: 0,
  lambda_logs: [
    {
      stack_name: 'apex-back-office-back-office-dev',
      lambda_function_name: 'backoffice-dev',
      log_group: '/aws/lambda/backoffice-dev',
      region: 'us-west-1',
      logs_found: 20,
      count_4xx: 20,
      count_5xx: 0,
      logs: [
        {
          timestamp: dayjs().subtract(30, 'minutes').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Invalid status value", "requestId": "2b61948d-33a6-4a4b-b3ee-d38687b7e79d", "method": "POST", "path": "/backoffice/secured/api/v1/lane-minimum-schedules/create", "statusCode": 400, "durationMs": 23.6, "success": false}',
          status_code: '400',
        },
        {
          timestamp: dayjs().subtract(1, 'hour').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Invalid status value", "requestId": "454f6e33-b7db-480f-aef9-1c8048651200", "method": "POST", "path": "/backoffice/secured/api/v1/lane-minimum-schedules/create", "statusCode": 400, "durationMs": 25.46, "success": false}',
          status_code: '400',
        },
      ],
    },
    {
      stack_name: 'apex-back-office-back-office-qa',
      lambda_function_name: 'backoffice-qa',
      log_group: '/aws/lambda/backoffice-qa',
      region: 'us-west-1',
      logs_found: 30,
      count_4xx: 30,
      count_5xx: 0,
      logs: [
        {
          timestamp: dayjs().subtract(2, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "PRO number 945401727 already exists in the system", "requestId": "8d8fa0b2-5e28-45f0-afd7-fe08065c0ff1", "method": "POST", "path": "/backoffice/secured/api/v1/create-shipment", "statusCode": 400, "durationMs": 185.15, "success": false}',
          status_code: '400',
        },
      ],
    },
  ],
}

/**
 * Mock CloudWatch Logs Data - Inbound Workstream
 */
export const mockCloudWatchLogsInbound = {
  workstream: 'inbound',
  environment: null,
  total_logs: 32,
  count_4xx: 25,
  count_5xx: 7,
  lambda_logs: [
    {
      stack_name: 'apex-inbound-inbound-prod',
      lambda_function_name: 'inbound-prod-shipment-processor',
      log_group: '/aws/lambda/inbound-prod-shipment-processor',
      region: 'us-west-1',
      logs_found: 18,
      count_4xx: 15,
      count_5xx: 3,
      logs: [
        {
          timestamp: dayjs().subtract(45, 'minutes').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "ERROR", "message": "Invalid shipment weight format", "requestId": "g7h8i9j0-k1l2-3456-ghij-567890123456", "method": "POST", "path": "/inbound/api/v1/shipments/receive", "statusCode": 400, "durationMs": 18.7, "success": false}',
          status_code: '400',
        },
        {
          timestamp: dayjs().subtract(2, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "ERROR", "message": "Service center database unreachable", "requestId": "h8i9j0k1-l2m3-4567-hijk-678901234567", "method": "GET", "path": "/inbound/api/v1/service-centers", "statusCode": 503, "durationMs": 10000, "success": false}',
          status_code: '503',
        },
      ],
    },
    {
      stack_name: 'apex-inbound-inbound-qa',
      lambda_function_name: 'inbound-qa-dock-scheduler',
      log_group: '/aws/lambda/inbound-qa-dock-scheduler',
      region: 'us-west-1',
      logs_found: 14,
      count_4xx: 10,
      count_5xx: 4,
      logs: [
        {
          timestamp: dayjs().subtract(3, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Dock door already occupied", "requestId": "i9j0k1l2-m3n4-5678-ijkl-789012345678", "method": "PUT", "path": "/inbound/api/v1/dock/assign", "statusCode": 409, "durationMs": 22.1, "success": false}',
          status_code: '409',
        },
      ],
    },
  ],
}

/**
 * Mock CloudWatch Logs Data - Outbound Workstream
 */
export const mockCloudWatchLogsOutbound = {
  workstream: 'outbound',
  environment: null,
  total_logs: 28,
  count_4xx: 22,
  count_5xx: 6,
  lambda_logs: [
    {
      stack_name: 'apex-outbound-outbound-prod',
      lambda_function_name: 'outbound-prod-route-planner',
      log_group: '/aws/lambda/outbound-prod-route-planner',
      region: 'us-west-1',
      logs_found: 16,
      count_4xx: 12,
      count_5xx: 4,
      logs: [
        {
          timestamp: dayjs().subtract(1, 'hour').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Delivery address validation failed", "requestId": "j0k1l2m3-n4o5-6789-jklm-890123456789", "method": "POST", "path": "/outbound/api/v1/routes/plan", "statusCode": 400, "durationMs": 35.4, "success": false}',
          status_code: '400',
        },
        {
          timestamp: dayjs().subtract(4, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "ERROR", "message": "External mapping service timeout", "requestId": "k1l2m3n4-o5p6-7890-klmn-901234567890", "method": "GET", "path": "/outbound/api/v1/geocode", "statusCode": 504, "durationMs": 30000, "success": false}',
          status_code: '504',
        },
      ],
    },
    {
      stack_name: 'apex-outbound-outbound-qa',
      lambda_function_name: 'outbound-qa-load-builder',
      log_group: '/aws/lambda/outbound-qa-load-builder',
      region: 'us-west-1',
      logs_found: 12,
      count_4xx: 10,
      count_5xx: 2,
      logs: [
        {
          timestamp: dayjs().subtract(2, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Load capacity exceeded", "requestId": "l2m3n4o5-p6q7-8901-lmno-012345678901", "method": "POST", "path": "/outbound/api/v1/loads/build", "statusCode": 400, "durationMs": 28.9, "success": false}',
          status_code: '400',
        },
      ],
    },
  ],
}

/**
 * Mock CloudWatch Logs Data - Dispatch Web Workstream
 */
export const mockCloudWatchLogsDispatchWeb = {
  workstream: 'dispatch-web',
  environment: null,
  total_logs: 18,
  count_4xx: 15,
  count_5xx: 3,
  lambda_logs: [
    {
      stack_name: 'apex-dispatch-dispatch-web-prod',
      lambda_function_name: 'dispatch-web-prod-assignment-handler',
      log_group: '/aws/lambda/dispatch-web-prod-assignment-handler',
      region: 'us-west-1',
      logs_found: 12,
      count_4xx: 10,
      count_5xx: 2,
      logs: [
        {
          timestamp: dayjs().subtract(1, 'hour').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Driver not available for assignment", "requestId": "m3n4o5p6-q7r8-9012-mnop-123456789012", "method": "POST", "path": "/dispatch/api/v1/assignments/create", "statusCode": 409, "durationMs": 19.3, "success": false}',
          status_code: '409',
        },
        {
          timestamp: dayjs().subtract(3, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "ERROR", "message": "Fleet management service unreachable", "requestId": "n4o5p6q7-r8s9-0123-nopq-234567890123", "method": "GET", "path": "/dispatch/api/v1/fleet/status", "statusCode": 503, "durationMs": 15000, "success": false}',
          status_code: '503',
        },
      ],
    },
    {
      stack_name: 'apex-dispatch-dispatch-web-qa',
      lambda_function_name: 'dispatch-web-qa-notification-sender',
      log_group: '/aws/lambda/dispatch-web-qa-notification-sender',
      region: 'us-west-1',
      logs_found: 6,
      count_4xx: 5,
      count_5xx: 1,
      logs: [
        {
          timestamp: dayjs().subtract(2, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Invalid phone number format", "requestId": "o5p6q7r8-s9t0-1234-opqr-345678901234", "method": "POST", "path": "/dispatch/api/v1/notifications/send", "statusCode": 400, "durationMs": 12.1, "success": false}',
          status_code: '400',
        },
      ],
    },
  ],
}

/**
 * Mock CloudWatch Logs Data - Dispatch Mobile Workstream
 */
export const mockCloudWatchLogsDispatchMobile = {
  workstream: 'dispatch-mobile',
  environment: null,
  total_logs: 24,
  count_4xx: 20,
  count_5xx: 4,
  lambda_logs: [
    {
      stack_name: 'apex-dispatch-mobile-prod',
      lambda_function_name: 'dispatch-mobile-prod-location-tracker',
      log_group: '/aws/lambda/dispatch-mobile-prod-location-tracker',
      region: 'us-west-1',
      logs_found: 15,
      count_4xx: 12,
      count_5xx: 3,
      logs: [
        {
          timestamp: dayjs().subtract(30, 'minutes').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "GPS coordinates out of service area", "requestId": "p6q7r8s9-t0u1-2345-pqrs-456789012345", "method": "POST", "path": "/mobile/api/v1/location/update", "statusCode": 400, "durationMs": 8.5, "success": false}',
          status_code: '400',
        },
        {
          timestamp: dayjs().subtract(2, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "ERROR", "message": "Location service database error", "requestId": "q7r8s9t0-u1v2-3456-qrst-567890123456", "method": "GET", "path": "/mobile/api/v1/location/history", "statusCode": 500, "durationMs": 2500, "success": false}',
          status_code: '500',
        },
      ],
    },
    {
      stack_name: 'apex-dispatch-mobile-qa',
      lambda_function_name: 'dispatch-mobile-qa-proof-uploader',
      log_group: '/aws/lambda/dispatch-mobile-qa-proof-uploader',
      region: 'us-west-1',
      logs_found: 9,
      count_4xx: 8,
      count_5xx: 1,
      logs: [
        {
          timestamp: dayjs().subtract(1, 'hour').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Image file size exceeds 10MB limit", "requestId": "r8s9t0u1-v2w3-4567-rstu-678901234567", "method": "POST", "path": "/mobile/api/v1/proof-of-delivery/upload", "statusCode": 413, "durationMs": 156.2, "success": false}',
          status_code: '413',
        },
      ],
    },
  ],
}

/**
 * Mock CloudWatch Logs Data - Dock Automation Workstream
 */
export const mockCloudWatchLogsDockAutomation = {
  workstream: 'dock-automation',
  environment: null,
  total_logs: 15,
  count_4xx: 12,
  count_5xx: 3,
  lambda_logs: [
    {
      stack_name: 'apex-dock-automation-prod',
      lambda_function_name: 'dock-automation-prod-door-controller',
      log_group: '/aws/lambda/dock-automation-prod-door-controller',
      region: 'us-west-1',
      logs_found: 10,
      count_4xx: 8,
      count_5xx: 2,
      logs: [
        {
          timestamp: dayjs().subtract(1, 'hour').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Dock door already in use", "requestId": "s9t0u1v2-w3x4-5678-stuv-789012345678", "method": "PUT", "path": "/dock/api/v1/doors/assign", "statusCode": 409, "durationMs": 14.2, "success": false}',
          status_code: '409',
        },
        {
          timestamp: dayjs().subtract(3, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "ERROR", "message": "Door sensor communication failure", "requestId": "t0u1v2w3-x4y5-6789-tuvw-890123456789", "method": "GET", "path": "/dock/api/v1/doors/status", "statusCode": 500, "durationMs": 5000, "success": false}',
          status_code: '500',
        },
      ],
    },
    {
      stack_name: 'apex-dock-automation-qa',
      lambda_function_name: 'dock-automation-qa-scheduling',
      log_group: '/aws/lambda/dock-automation-qa-scheduling',
      region: 'us-west-1',
      logs_found: 5,
      count_4xx: 4,
      count_5xx: 1,
      logs: [
        {
          timestamp: dayjs().subtract(2, 'hours').format(DaylightDateFormat.TIMESTAMP_WITH_MS),
          message:
            '{"level": "WARNING", "message": "Time slot already reserved", "requestId": "u1v2w3x4-y5z6-7890-uvwx-901234567890", "method": "POST", "path": "/dock/api/v1/schedule/reserve", "statusCode": 409, "durationMs": 25.8, "success": false}',
          status_code: '409',
        },
      ],
    },
  ],
}
